import { render } from "./pdf-icon.svg?vue&type=template&id=3b751ba8"
import script from "./pdf-icon.svg?vue&type=script&lang=js"
export * from "./pdf-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3609/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__